import { render, staticRenderFns } from "./productRecomed.vue?vue&type=template&id=9b799eae&scoped=true"
import script from "./productRecomed.vue?vue&type=script&lang=js"
export * from "./productRecomed.vue?vue&type=script&lang=js"
import style0 from "./productRecomed.vue?vue&type=style&index=0&id=9b799eae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b799eae",
  null
  
)

export default component.exports